/*
 * @Author: caiqin.xie
 * @since: 2023-06-09 14:56:39
 * @lastTime: 2023-11-02 17:13:58
 * @LastEditors: caiqin.xie
 * @message: 订阅组件
 */
import React, { useState } from "react";
import { Input, Notification } from '@arco-design/web-react';
import styles from "./index.module.scss";
import request from '@/common/request'
import { DOMAIN_API } from '@/common/const'

interface IProps {
  ctry: string;
  words: Record<string, string>;
  className?: string;
  contentTypeId: string; // 订阅内容类型
  sourcePage: string; // 订阅页面 l=>blog列表 2=>blog详情
  sourceUrl: string; // 订阅页面地址
}

const Subscribe = (props:IProps) => {
  const {ctry, words, className, contentTypeId, sourcePage, sourceUrl} = props
  const [email, setEmail] = useState('')

  // 订阅
  const handleClick = () => {
    console.log(email)
    const emailRegExp=/^([a-zA-Z0-9_.-]+)@([a-zA-Z0-9_-]+).([a-zA-Z0-9_-]+)(.[a-zA-Z0-9_-]+)*$/;
    if (!emailRegExp.test(email)) {
      Notification.error({
        title: '',
        content: words.blog_subscribe_email_error,
      })
      // 请输入有效的电子邮件地址
      return false
    }
    console.log(email)
    request.post(`${DOMAIN_API}/o/consult/save`, {
      email,
      contentTypeId,
      sourcePage,
      stationCode: ctry,
      sourceUrl
    })
    .then(res => {
      console.log(res)
      Notification.success({
        title: '',
        content: words.blog_subscribe_success,
      })
      // Success
    })
    .catch(err => {
      console.log(err)
    })
  }

  return (
    <div className={`${styles['subscribe-wrap']} ${className}`}>
      <p className={styles['subscribe-desc']}>{words?.blog_subscribe_desc}</p>
      {/* Be the first to know new product launch, offerings, and news from PICO! */}
      <Input
        className="subscribe-input"
        allowClear
        size="large"
        value={email}
        onPressEnter={handleClick}
        onChange={(value) => setEmail(value)}
        placeholder={words?.blog_email_placeholder} />
        {/* Submit your email address */}
      <button className={styles["subscribe-purple-btn"]} onClick={handleClick}>{words?.blog_subscribe}</button>
      {/* Subscribe */}
    </div>
  )
}
export default Subscribe
